const NON_PERSISTED_APP_STORE_KEYS = new Set(["_old_webphone", "userData", "webphoneExpanded", "webphoneDetached"])

export function getPersistedAppStoreState<T extends object>(state: T): Partial<T> {
  const stateRecord = state as Record<string, unknown>

  return Object.fromEntries(Object.entries(stateRecord).filter(([key]) => !NON_PERSISTED_APP_STORE_KEYS.has(key))) as Partial<T>
}
